import { useEffect } from "react"
import { useFormikContext } from "formik"
import { useContext } from "react"
import { UserContext } from "../../../context/userContext"
import { FormContext } from "../../../context/formContext"

import styles from "../../../styles/Form.module.css"

export default function OrganizationId({ field, index }) {
  const formik = useFormikContext()
  const form = useContext(FormContext)
  const userCtx = useContext(UserContext)

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    formik.setFieldValue(
      field.field_name,
      userCtx.session.user.enterprise_id
    )

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={styles.hidden} style={{ order: index }}>
      <input
        type="hidden"
        name={field.field_name}
        value={formik.values[field.field_name]}
      />
    </div>
  )
}
